import { Button } from '@mui/material'
import React from 'react'
import { type ISendButtonArgs } from './types'

export const SendButton = ({ label, onClick, className }: ISendButtonArgs) => <Button className={className} variant="contained" href="#contained-buttons" onClick={onClick}>
    {label}
</Button>
